import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsManageiqComponent } from './simple-icons-manageiq.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsManageiqComponent ],
    exports:      [ SimpleIconsManageiqComponent ],
    bootstrap:    []
})
export class SimpleIconsManageiqModule {}
